/*
 *
 * RtlSupport actions
 *
 */

import { createAction } from "redux-actions";
import { ENABLE_RTL_SUPPORT } from "./constants";

export const enableRtlSupport = createAction(ENABLE_RTL_SUPPORT);
